import { createSelector, createFeatureSelector } from '@ngrx/store';

import {
  getGroups,
  getGroupsIsLoading,
  GroupReducer,
  GroupState,
} from './groups';
import {
  getLicenses,
  getLicensesIsLoading,
  LicenseReducer,
  LicenseState,
} from './licenses';

export const stateName = 'featureToggles';

export interface FeatureToggleState {
  group: GroupState;
  license: LicenseState;
}

export const featureToggleReducers = {
  group: GroupReducer,
  license: LicenseReducer,
};

const featureToggleState = createFeatureSelector<FeatureToggleState>(stateName);

// Group State
const groupState = createSelector(featureToggleState, (state) => state.group);
export const getFeatureToggleGroups = createSelector(groupState, getGroups);
export const getFeatureToggleGroupsIsLoading = createSelector(
  groupState,
  getGroupsIsLoading,
);

// License State
const licenseState = createSelector(
  featureToggleState,
  (state) => state.license,
);
export const getFeatureToggleLicenses = createSelector(
  licenseState,
  getLicenses,
);
export const getFeatureToggleLicensesIsLoading = createSelector(
  licenseState,
  getLicensesIsLoading,
);
